var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgUndoIcon = function SvgUndoIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M6.325 7.034c-.136.136-.09.247.105.247h6.024a3.86 3.86 0 0 1 3.859 3.86 3.857 3.857 0 0 1-3.86 3.86h-3.16a.703.703 0 0 1 0-1.404h3.16a2.455 2.455 0 1 0 0-4.912H6.43c-.194 0-.238.113-.105.246l.837.837a.7.7 0 0 1-.001.991.7.7 0 0 1-.994 0L3.889 8.48a.7.7 0 0 1 0-.995l2.278-2.279a.702.702 0 0 1 .995.991z"
  })));
};
export { SvgUndoIcon as ReactComponent };